import { Button, makeStyles, useTheme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styles } from './balanceError.styles';

export interface BalanceErrorProps {
  email?: string;
  onRefresh?: () => void;
  onReportError?: () => void;
  onLogout?: () => void;
}

export const BalanceError: React.FC<BalanceErrorProps> = props => {
  const [t] = useTranslation(['httpErrors']);
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorCode}>
        <img alt="Globaleris" src={process.env.PUBLIC_URL + '/images/globaleris-error-http.png'} />
      </div>
      <div className={classes.errorDescription}>
        <h1>{t('httpErrors:balance.title')}</h1>
        <p>
          {t('httpErrors:balance.subtitle')}
          <br />
          {t('httpErrors:balance.text')}
        </p>
        <p>{t('httpErrors:balance.userInfo', { email: props.email })}</p>
        {props.onRefresh && (
          <Button
            className={classes.actionButton}
            variant="contained"
            color="primary"
            onClick={() => {
              props.onRefresh && props.onRefresh();
            }}
          >
            {t('httpErrors:balance.actions.refresh')}
          </Button>
        )}
        {props.onReportError && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              props.onReportError && props.onReportError();
            }}
          >
            {t('httpErrors:balance.actions.report')}
          </Button>
        )}
        {props.onLogout && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              props.onLogout && props.onLogout();
            }}
          >
            {t('httpErrors:balance.actions.logout')}
          </Button>
        )}
      </div>
    </div>
  );
};
